<div class="ui-control ui-inline-control" [formGroup]="formGroup">
  <span class="input-label">{{inputData.label}}</span>
  <p-checkbox class="input-control" class="box-rounded" binary="true" [formControlName]="inputData.colName"></p-checkbox>
</div>